import { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "./PotectedRoute";
import TokenPage from "../pages/Token/token";
import ReprintToken from "../pages/ReprintToken/reprintToken";
import ForgotPassword from "../pages/ForgotPassword/forgotPassword";
import AuditLog from "../pages/Report/AuditLog/auditlog";
import CustomerPopulation from "../pages/Report/CustomerPopulation/customerPopulation";
import CustomerSetup from "../pages/Report/CustomerSetup/customerSetup";
import DailySaleReport from "../pages/Report/DailySales/dailySales";
import MonthsWithoutSales from "../pages/Report/MonthWithoutSales/monthsWithoutSales";
import Settings from "../pages/Settings/settings";
import TransactionReport from "../pages/Report/TransactionReport/transactionReport";
import SelfServiceAdminHome from "../pages/SelfServiceAdminHome/SelfServiceAdminHome";
import SelfServiceAdminReport from "../pages/SelfServiceAdminReport/SelfServiceAdminReport";
import { USER_TYPE } from "../components/Utils/constants";
import Unauthorized from "../pages/Unauthorized/Unauthorized";
import HelpCenter from "../pages/HelpCenter/HelpCenter";
import SelfServiceAdminSpecialTokens from "../pages/SelfServiceAdminSpecialTokens/SelfServiceAdminSpecialTokens";

const Login = lazy(() => import("../pages/Login/login"));

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/unauthorized" element={<Unauthorized />} />

      {/* Shared routes - both ADMIN and SELF_SERVICE_ADMIN can access */}
      <Route element={<ProtectedRoute allowedRoles={[USER_TYPE.ADMIN, USER_TYPE.SELF_SERVICE_ADMIN]} />}>
        <Route path="/settings" element={<Settings />} />
        <Route path="/help-center" element={<HelpCenter />} />
      </Route>

      {/* Admin-only routes */}

      <Route element={<ProtectedRoute allowedRoles={[USER_TYPE.ADMIN]} />}>
        <Route path="/token" element={<TokenPage />} />
        <Route path="/reprint-credit-token" element={<ReprintToken />} />
        <Route path="/special-tokens" element={<SelfServiceAdminSpecialTokens />} />
        <Route path="/report/audit-log" element={<AuditLog />} />
        <Route path="/report/customer-population" element={<CustomerPopulation />} />
        <Route path="/report/customer-setup" element={<CustomerSetup />} />
        <Route path="/report/daily-sales-point" element={<DailySaleReport />} />
        <Route path="/report/months-without-sales" element={<MonthsWithoutSales />} />
        <Route path="/report/transaction-report" element={<TransactionReport />} />
      </Route>

      {/* Self-service admin routes */}
      <Route element={<ProtectedRoute allowedRoles={[USER_TYPE.SELF_SERVICE_ADMIN]} />}>
        <Route path="/home" element={<SelfServiceAdminHome />} />
        <Route path="/self-service-special-tokens" element={<SelfServiceAdminSpecialTokens />} />
        <Route path="/self-service-report" element={<SelfServiceAdminReport />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
